import React from 'react';
import { useLanguage } from '../../Providers/LanguageContext'
import SignUpButton from './SignUpButton';
import iMg1 from "../../images/ilustraciones soluciones industriales_EDUCACION 1.png";
import iMg2 from "../../images/ilustraciones soluciones industriales_EDUCACION 2.png";
import iMg3 from "../../images/ilustraciones soluciones industriales_EDUCACION 3.png";
import iMg3en from "../../images/ilustraciones soluciones industriales_EDUCACION 3 EN.png";
import AgricultureBanner from './AgricultureBanner';

const Education = () => {
  const { language, currentLanguage } = useLanguage();

  return (
    <div>
      <AgricultureBanner education={true} />

      <section id='agriculture_sec' style={{
        background: '#0c2637',
        padding: '0px 0px 30px 0px'
      }}>
        <div className='container-fluid'>
          <div className='row mb-5'>
            <div className='col-md-5 col-12 m-auto agriculture_box'>
              {/* <div className='agriculture_head'>
                <h3 style={{ color: "#3fa9f5" }}>{language.education}</h3>
              </div> */}

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '38px', fontWeight: '700' }}>{language.simplify_budgeting}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_edu_institution}</p>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.app_catogrise_expanse}</p>
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg1} className='img-fluid' alt='' />
              </div>
            </div>
          </div>

          <div className='row row_reverse mb-5'>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg2} className='img-fluid' alt='' />
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto agriculture_box'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '38px', fontWeight: '700', textAlign: "right" }}>{language.streamline_exp_track}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_school_university}</p>
              </div>

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "left", fontSize: '38px', fontWeight: '700' }}>{language.time_saving_automation}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}> {language.fisi_edu_automate}</p>
              </div>
            </div>
          </div>

          {/* <div className='row mb-5'>
            <div className='col-md-12 col-12'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#b6cc2b", textAlign: "left" }}>{language.time_saving_automation}</h4>
                <p> {language.fisi_edu_automate}</p>
              </div>
            </div>
          </div> */}

          <div className='row mb-5'>
            <div className='col-md-5 col-12 agriculture_box'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "left", fontSize: '38px', fontWeight: '700' }}>{language.improve_finan_tranparancy}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_prov_tran_finanve}</p>
              </div>

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "right", fontSize: '38px', fontWeight: '700' }}>{language.increased_finance_security}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.prov_secure_access_finance}</p>
              </div>
            </div>


            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img' style={{ maxWidth: "100%", }}>
                {
                  currentLanguage === 'spanish'
                    ?
                    <img src={iMg3} className='img-fluid' alt='' style={{ marginBottom: "30px" }} />
                    :
                    <img src={iMg3en} className='img-fluid' alt='' style={{ marginBottom: "30px" }} />

                }

                {/* <div className='registrarAnddescargar' style={{ transform: "translate(-50% , -50%)", top: "100%", }}>
                  <button className='registrar_Btn'>Registrarse</button>
                  <button className='descargar_Btn'>Descargar</button>
                </div> */}
                <SignUpButton />
              </div>
            </div>
          </div>


        </div>
      </section>

    </div>
  )
}

export default Education